import { createStore } from "vuex";

import Token from "./utilities/jwt/Token.js";

export default createStore({
  state() {
    return {
      userLogged: null,
      views: {
        equipament: {
          dialogForm: false,
        },
        local: {
          dialogForm: false,
        },
        calendar: {
          dialogDetails: false,
          dialogSearch: false,
          dialogRules: false,
        },
        event: {
          dialogDetails: false,
          dialogForm: false,
          editionMode: false,
          dialogCancel: false,
          dialogRequesteds: false,
        },
        responsible: {
          dialogForm: false,
        },
      },
    };
  },
  getters: {
    getUserLogged(state) {
      return state.userLogged;
    },
    getSelectType(state) {
      return state.views.external.selectType;
    },
    getDialogExternalCard(state) {
      return state.views.external.dialogExternalCard;
    },
  },
  mutations: {
    setUserLogged(state, token) {
      token = [
        {
          nome: token.name,
          id: token.code,
          services: token.services,
          email: token.user_name,
          authorities: token.authorities,
          personId: token.personId,
        },
      ];
      state.userLogged = token[0];
    },
  },
  actions: {
    setUserLogged({ commit }) {
      commit("setUserLogged", new Token().decodeToken('access_token'));
    },
  },
});
